import styles from './AssetOwnerIsolatedView.module.scss';
import Accordion from 'client/components/aria/Accordion';
import { getLocale } from 'i18n/localeUtils';
import { useOwnerPreferenceCheckboxes, useOwnerSectorSymbology } from '../OwnerPreferences';
import useAssetOwnerIsolationState from './useAssetOwnerIsolationState';
import AssetOwnerAccordionHeader from '../AssetOwnerAccordionHeader/AssetOwnerAccordionHeader';
import NetworkControls from '../NetworkControls/NetworkControls';
import PreferenceSections from '../PreferenceSections/PreferenceSections';

const AssetOwnerIsolatedView = ({ owner, dataTestId: dataTestIdBase }) => {
    const locale = getLocale();

    const { checkboxes, handleCheckboxChange } = useOwnerPreferenceCheckboxes(owner.dataProviderId);
    const { sectorSymbology } = useOwnerSectorSymbology(owner.dataProviderId);

    const {
        categoriesForOwner,
        selectedAssetCategory,
        onlyHasOneCategory,
        hideAllOption,
        handleSelectAll,
        handleChange,
        handleAccordionHeading,
        selectedOwner
    } = useAssetOwnerIsolationState({ owner, sectorSymbology });

    const ownerTestId = `${dataTestIdBase}.owner.${owner.dataProviderId}`;

    return (
        <Accordion
            key={`owner-${owner.dataProviderId}-${selectedOwner === owner.dataProviderId}`}
            isSelected={selectedOwner === owner.dataProviderId}
            title={<AssetOwnerAccordionHeader owner={owner} data-testid={`${ownerTestId}.heading`} />}
            variant='bare'
            titleClassName={styles.accordionFocus}
            onChange={() => handleAccordionHeading(owner.dataProviderId)}
        >
            <div className={styles.content} data-testid={`${ownerTestId}.content`}>
                <NetworkControls
                    categoriesForOwner={categoriesForOwner}
                    selectedAssetCategory={selectedAssetCategory}
                    onlyHasOneCategory={onlyHasOneCategory}
                    hideAllOption={hideAllOption}
                    locale={locale}
                    owner={owner}
                    dataTestIdBase={dataTestIdBase}
                    onSelectAll={handleSelectAll}
                    onSelectCategory={handleChange}
                />

                <PreferenceSections
                    owner={owner}
                    checkboxes={checkboxes}
                    onCheckboxChange={handleCheckboxChange}
                    dataTestIdBase={dataTestIdBase}
                />
            </div>
        </Accordion>
    );
};

export default AssetOwnerIsolatedView;
